exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay[data-v-0694fcf2]{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.7);z-index:800}.loader[data-v-0694fcf2]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background-color:#fff;height:85px;width:85px;border-radius:50%;z-index:900;text-align:center}.loader i[data-v-0694fcf2]{display:block;margin:0 auto}.loader i[data-v-0694fcf2]:before{content:\".\";animation-name:load-data-v-0694fcf2;animation-duration:.8s;animation-iteration-count:infinite;width:auto;color:#000;display:inline-block;font-size:40px}@keyframes load-data-v-0694fcf2{0%{content:\".\"}33%{content:\"..\"}66%{content:\"...\"}to{content:\".\"}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0694fcf2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"silenceDeprecations":["legacy-js-api","import","global-builtin","color-functions","slash-div"],"quietDeps":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Global/Loader.vue
// module id = 632
// module chunks = 0